import { frameworkLayouts } from "../../../core/components/layouts/configuration/layoutsconfiguration"


frameworkLayouts.data = {

    layouts: [


        {

            "name": "image_basegame-bg1",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,

        },
        {

            "name": "image_cloud_a_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -46,
            "y": 0

        }, {

            "name": "image_cloud_b_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1065,
            "y": 0

        },
        {
            "name": "image_basegameSky-bg_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },

        {

            "name": "image_freegame-fg1",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "x": 0,
            "y": 0,

        },
        {

            "name": "image_freegameTop-fg_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "x": 0,
            "y": 0,

        },
        {

            "name": "mobileViewBottomBArImage1",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 872
        },
        {

            "name": "mobileViewBottomBArImage1",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 1790,

        },


        {

            "name": "mobileViewBottomBArImage2",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 1010

        },
        {

            "name": "mobileViewBottomBArImage2",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 1720,

        },


        {

            "name": "btn_home",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 80,
            "y": 890,

        },
        {

            "name": "btn_home",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 80,
            "y": 1820,

        },


        {

            "name": "autoplay_StartButton",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": true,
            "x": 1684,
            "y": 964,

        },
        {

            "name": "autoplay_StartButton",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": true,
            "x": 100,
            "y": 909,

        },
        {

            "name": "btn_spin",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": true,
            "x": 1770,
            "y": 900,

        },
        {

            "name": "btn_spin",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": true,
            "x": 10,
            "y": 900,

        },
        {

            "name": "btn_stake",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": true,
            "x": 1594,
            "y": 964,

        },
        {

            "name": "btn_stake",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": true,
            "x": 240,
            "y": 964,

        },
        {

            "name": "btn_autoplay",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": true,
            "x": 1684,
            "y": 964,
        },
        {

            "name": "btn_autoplay",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": true,
            "x": 155,
            "y": 964,

        },
        {

            "name": "btn_autoplay_stopdesktop",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": false,
            "x": 1770,
            "y": 900,
        },
        {

            "name": "btn_autoplay_stopdesktop",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": false,
            "x": 10,
            "y": 900,

        },
        {

            "name": "btn_paytable",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": true,
            "x": 1622,
            "y": 964,

        },
        {

            "name": "btn_paytable",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": true,
            "x": 228,
            "y": 963,

        },
        {

            "name": "btn_menu",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": true,
            "x": 1800,
            "y": 935,

        },
        {

            "name": "btn_menu",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": true,
            "x": 26,
            "y": 939,

        },
        {

            "name": "btn_menu_close",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": false,
            "x": 1800,
            "y": 935,

        },
        {

            "name": "btn_menu_close",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": false,
            "x": 26,
            "y": 939,

        },
        {

            "name": "btn_sound",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": true,
            "x": 1715,
            "y": 964,

        },
        {

            "name": "btn_sound",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": true,
            "x": 138,
            "y": 964,

        },
        {

            "name": "btn_soundOff",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": true,
            "x": 1715,
            "y": 964,

        },
        {

            "name": "btn_soundOff",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": true,
            "x": 138,
            "y": 964,

        },
        {

            "name": "settingBtnContainer",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": false,
            "x": 1812,
            "y": 954,

        },
        {

            "name": "settingBtnContainer",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": false,
            "x": 40,
            "y": 954,

        },
        {

            "name": "gameRulesBtnContainer",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": false,
            "x": 1812,
            "y": 954,

        },
        {

            "name": "gameRulesBtnContainer",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": false,
            "x": 40,
            "y": 954,

        },
        {

            "name": "historyBtnContainer",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "desktop",
            "visible": false,
            "x": 1812,
            "y": 954,

        },
        {

            "name": "historyBtnContainer",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "desktop",
            "visible": false,
            "x": 40,
            "y": 954,

        },
        {

            "name": "btn_spin",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 10,
            "y": 490,

        },
        {

            "name": "btn_spin",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1665,
            "y": 374,

        },
        {

            "name": "btn_spin",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 441,
            "y": 1413,

        },

        {

            "name": "btn_spin",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 441,
            "y": 1413,

        },
        /*    {
   
               "name": "btn_spinStop",
               "screenMode": "Landscape",
               "handMode": "left",
               "uiMode": "mobile",
               "visible": false,
               "x": 55,
               "y": 532,
   
           },
           {
   
               "name": "btn_spinStop",
               "screenMode": "Landscape",
               "handMode": "right",
               "uiMode": "mobile",
               "visible": false,
               "x": 1708,
               "y": 416,
   
           },
           {
   
               "name": "btn_spinStop",
               "screenMode": "Portrait",
               "handMode": "right",
               "uiMode": "mobile",
               "visible": false,
               "x": 483,
               "y": 1455,
   
           },
   
           {
   
               "name": "btn_spinStop",
               "screenMode": "Portrait",
               "handMode": "left",
               "uiMode": "mobile",
               "visible": false,
               "x": 483,
               "y": 1455,
   
           }, */
        {

            "name": "btn_spinFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 441,
            "y": 1413,

        },
        {

            "name": "btn_spinFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 441,
            "y": 1413,

        },

        {

            "name": "btn_spinStoke",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1604,
            "y": 357,

        },
        {

            "name": "btn_spinStoke",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 297,
            "y": 475,

        },
        {

            "name": "btn_spinStoke",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 682,
            "y": 1350,

        },
        {

            "name": "btn_spinStoke",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 682,
            "y": 1350,

        },
        {

            "name": "btn_spinStokeFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 682,
            "y": 1350,

        },
        {

            "name": "btn_spinStokeFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 682,
            "y": 1350,

        },
        {

            "name": "image_commongame-bg",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 0,
            "y": 0,


        },
        {

            "name": "image_commongame-bg",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 0,
            "y": 0,

        },

        {

            "name": "image_commongame-potrait-bg",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 540,
            "y": 960,


        },
        {

            "name": "image_commongame-potrait-bg",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,

        },


        {

            "name": "Mobiletext_win_label",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 795,
            "y": 936,

        },
        {

            "name": "Mobiletext_win_label",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 340,
            "y": 1620,

        },

        {

            "name": "Mobiletext_mobColonSymbol1",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 876,
            "y": 932,

        },
        {

            "name": "Mobiletext_mobColonSymbol1",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 426,
            "y": 1618,

        },

        {

            "name": "Mobiletext_win_value",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            // "visible": true,

            "x": 928,
            "y": 936,

        },
        {

            "name": "Mobiletext_win_value",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            // "visible": true,
            "x": 504,
            "y": 1620,

        },


        {

            "name": "Mobiletext_balance_label",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 170,
            "y": 1050,

        },
        {

            "name": "Mobiletext_balance_label",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 150,
            "y": 1754,

        },

        {

            "name": "Mobiletext_mobColonSymbol2",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 274,
            "y": 1048,

        },
        {

            "name": "Mobiletext_mobColonSymbol2",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 250,
            "y": 1754,

        },

        {

            "name": "Mobiletext_balance_value",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 300,
            "y": 1050,

        },
        {

            "name": "Mobiletext_balance_value",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 286,
            "y": 1754,

        },


        {

            "name": "Mobiletext_bet_label",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 1600,
            "y": 1050,


        },
        {

            "name": "Mobiletext_bet_label",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 800,
            "y": 1754,

        },

        {

            "name": "Mobiletext_mobColonSymbol3",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 1650,
            "y": 1048,

        },
        {

            "name": "Mobiletext_mobColonSymbol3",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 850,
            "y": 1754,

        },

        {

            "name": "Mobiletext_bet_value",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 1674,
            "y": 1050,

        },
        {

            "name": "Mobiletext_bet_value",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 880,
            "y": 1754,

        },


        {

            "name": "BG_gameLogo_Anim",
            "uiMode": "desktop",
            "screenMode": "",
            "handMode": "right",
            "visible": true,
            "x": 138.5,
            "y": 186.5,


        },
        {

            "name": "BG_gameLogo_Anim",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 138.5,
            "y": 186.5,

        },
        {

            "name": "BG_gameLogo_Anim",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": 528.5,
            "y": 156.5,
        },


        {

            "name": "BG_frame_Image",
            "uiMode": "desktop",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 959.5,
            "y": 502.5


        },
        {

            "name": "BG_frame_Image",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 959.5,
            "y": 502.5

        },

        {

            "name": "BG_frame_Image",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 0,
            "y": 0,
        },


        {

            "name": "BG_frame_Image",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 540,
            "y": 960,
        },


        {

            "name": "BG_river_Anim_Mob",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 195,
            "y": 748,
        },
        {

            "name": "BG_leftTorchFlame_Anim_mobile",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 135,
            "y": 715,
        },
        {

            "name": "BG_rightTorchFlame_Anim_mobile",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 1778,
            "y": 715,
        },
        {

            "name": "BG_waterfall_Anim_mobile",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 1780.5,
            "y": 462,
        },
        {

            "name": "BG_gameLogo_Anim_mobile",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 128.5,
            "y": 186.5,
        },
        {

            "name": "FG_gameLogo_Anim_mobile",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 118.5,
            "y": 186.5,
        },
        {

            "name": "FG_gameLogo_Anim_mobile",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "visible": true,
            "x": 118.5,
            "y": 186.5,
        },
        {

            "name": "FG_gameLogo_Anim_mobile",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": 538.5,
            "y": 176.5,
        },
        {

            "name": "FG_gameLogo_Anim_mobile",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "visible": true,
            "x": 538.5,
            "y": 176.5,
        },
        {

            "name": "BG_gameLogo_Anim_mobile",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": 538.5,
            "y": 176.5,
        },
        //  {

        //      "name": "BG_frame_Image_Mobile",
        //      "uiMode": "mobile",
        //      "screenMode": "Landscape",
        //      "handMode": "right",
        //      "visible": true,
        //      "x": 959.5,
        //      "y": 539.5
        //  },
        //  {

        //      "name": "BG_frame_Image_Mobile",
        //      "uiMode": "mobile",
        //      "screenMode": "Portrait",
        //      "handMode": "right",
        //      "visible": true,
        //      "x": 541.5,
        //      "y": 1017.5,
        //  },
        {

            "name": "BG_reelOfFrame_Image_Mobile",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 959.5,
            "y": 502.5
        },
        {

            "name": "BG_reelOfFrame_Image_Mobile",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": 545,
            "y": 772,
        }, {

            "name": "frameReel_FG_Image_Mob",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 295.5,
            "y": 76
        },
        {

            "name": "frameReel_FG_Image_Mob",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "visible": true,
            "x": 295.5,
            "y": 76
        },
        {

            "name": "frameReel_FG_Image_Mob",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": 1,
            "y": 408,
        },
        {

            "name": "frameReel_FG_Image_Mob",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "visible": true,
            "x": 1,
            "y": 408,
        },
        {

            "name": "frame_FG_Image_Mob",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": -2.5,
            "y": -3
        },
        {

            "name": "frame_FG_Image_Mob",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "visible": true,
            "x": -2.5,
            "y": -3
        },
        {

            "name": "frame_FG_Image_Mob",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": -299,
            "y": 319,
        },
        {

            "name": "frame_FG_Image_Mob",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "visible": true,
            "x": -299,
            "y": 319,
        },
        {

            "name": "btn_homeFG",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 80,
            "y": 890,

        },
        {

            "name": "btn_homeFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 60,
            "y": 1750,

        },

        {
            "name": "btn_autoplay",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1613,
            "y": 466,

        },
        {
            "name": "btn_autoplay",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 250,
            "y": 590,

        },
        {
            "name": "btn_autoplay",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 536,
            "y": 1365,

        },
        {
            "name": "btn_autoplay",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 536,
            "y": 1365,

        },




        {

            "name": "btn_autoplay_stopmobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1708,
            "y": 414,
        },
        {

            "name": "btn_autoplay_stopmobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 52,
            "y": 533,
        },
        {

            "name": "btn_autoplay_stopmobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 482,
            "y": 1455,


        },
        {

            "name": "btn_autoplay_stopmobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 482,
            "y": 1455,


        },

        {
            "name": "btn_autoplayFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 536,
            "y": 1365,

        },
        {
            "name": "btn_autoplayFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 536,
            "y": 1365,

        },


        {
            "name": "btn_autoplay_opened",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1613,
            "y": 466,

        },
        {
            "name": "btn_autoplay_opened",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1613,
            "y": 466,

        },


        //{

        //    "name": "mobileViewBottomBArImage1FG",
        //    "screenMode": "Landscape",
        //    "handMode": "right",
        //    "uiMode": "mobile",
        //    "visible": true,
        //    "x": 0,
        //    "y": 860

        //},
        //{

        //    "name": "mobileViewBottomBArImage1FG",
        //    "screenMode": "Portrait",
        //    "handMode": "right",
        //    "uiMode": "mobile",
        //    "visible": true,
        //    "x": 0,
        //    "y": 1710,

        //},
        //{

        //    "name": "mobileViewBottomBArImage2FG",
        //    "screenMode": "Landscape",
        //    "handMode": "right",
        //    "uiMode": "mobile",
        //    "visible": true,
        //    "x": 0,
        //    "y": 1010

        //},
        //{

        //    "name": "mobileViewBottomBArImage2FG",
        //    "screenMode": "Portrait",
        //    "handMode": "right",
        //    "uiMode": "mobile",
        //    "visible": true,
        //    "x": 0,
        //    "y": 1850,

        //},


        {

            "name": "multiplierFrame_FG_Image_mob",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1655,
            "y": 370

        },
        {

            "name": "multiplierFrame_FG_Image_mob",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1655,
            "y": 370

        },
        {

            "name": "multiplierFrame_FG_Image_mob",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 793,
            "y": 233

        },
        {

            "name": "multiplierFrame_FG_Image_mob",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 793,
            "y": 233

        },
        {

            "name": "multiplierText_mob",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 140,
            "y": 510,

        },
        {

            "name": "multiplierText_mob",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 160,
            "y": 1333,

        },


        {

            "name": "text_FreeGame_label_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 469,
            "y": 940,
        },
        {

            "name": "text_FreeGame_label_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "visible": true,
            "x": 469,
            "y": 940,
        },
        {

            "name": "text_FreeGame_label_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": 410,
            "y": 1806,
        },
        {

            "name": "text_FreeGame_label_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "visible": true,
            "x": 410,
            "y": 1806,
        },
        {

            "name": "text_FreeGame_value1",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 1686,
            "y": 289,
        },

        {

            "name": "text_FreeGame_value1",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": 482,
            "y": 1257,
        },

        {

            "name": "text_FreeGame_OF_label_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 720,
            "y": 940,
        },
        {

            "name": "text_FreeGame_OF_label_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "visible": true,
            "x": 720,
            "y": 940,
        },
        {

            "name": "text_FreeGame_OF_label_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": 668,
            "y": 1806,
        },
        {

            "name": "text_FreeGame_OF_label_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "visible": true,
            "x": 668,
            "y": 1806,
        },

        {

            "name": "text_FreeGame_value2",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 1858,
            "y": 290,
        },

        {

            "name": "text_FreeGame_value2",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": 656,
            "y": 1257,
        },


        {

            "name": "text_TotalWin_label_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 1164,
            "y": 940,
        },
        {

            "name": "text_TotalWin_label_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "visible": true,
            "x": 1164,
            "y": 940,
        },
        {

            "name": "text_TotalWin_value_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "visible": true,
            "x": 1400,
            "y": 940,
        },
        {

            "name": "text_TotalWin_value_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "visible": true,
            "x": 1400,
            "y": 940,
        },

        {

            "name": "text_TotalWin_value_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "visible": true,
            "x": 570,
            "y": 1643,
        },
        {

            "name": "text_TotalWin_value_mobileFG",
            "uiMode": "mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "visible": true,
            "x": 570,
            "y": 1643,
        },

        {

            "name": "Mobiletext_balance_labelFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 150,
            "y": 1900,

        },
        {

            "name": "Mobiletext_balance_labelFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,

            "x": 150,
            "y": 1900,

        },
        {

            "name": "Mobiletext_mobColonSymbol2FG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 250,
            "y": 1900,

        },
        {

            "name": "Mobiletext_mobColonSymbol2FG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,

            "x": 250,
            "y": 1900,

        },
        {

            "name": "Mobiletext_balance_valueFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 366,
            "y": 1900,

        },
        {

            "name": "Mobiletext_balance_valueFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,

            "x": 366,
            "y": 1900,

        },

        {

            "name": "Mobiletext_bet_labelFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 800,
            "y": 1900,

        },
        {

            "name": "Mobiletext_bet_labelFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,

            "x": 800,
            "y": 1900,

        },
        {

            "name": "Mobiletext_mobColonSymbol3FG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 860,
            "y": 1900,

        },
        {

            "name": "Mobiletext_mobColonSymbol3FG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,

            "x": 860,
            "y": 1900,

        },
        {

            "name": "Mobiletext_bet_valueFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 940,
            "y": 1900,

        },
        {

            "name": "Mobiletext_bet_valueFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,

            "x": 940,
            "y": 1900,

        },


        {

            "name": "Mobiletext_balance_labelFG",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 170,
            "y": 1050,


        },
        {

            "name": "Mobiletext_balance_labelFG",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 170,
            "y": 1050,


        },
        {

            "name": "Mobiletext_mobColonSymbol2FG",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 294,
            "y": 1048,


        },
        {

            "name": "Mobiletext_mobColonSymbol2FG",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 294,
            "y": 1048,


        },
        {

            "name": "Mobiletext_balance_valueFG",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,

            "x": 320,
            "y": 1050,

        },
        {

            "name": "Mobiletext_balance_valueFG",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,

            "x": 320,
            "y": 1050,

        },

        {

            "name": "Mobiletext_bet_labelFG",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1600,
            "y": 1050,


        },
        {

            "name": "Mobiletext_bet_labelFG",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1600,
            "y": 1050,


        },
        {

            "name": "Mobiletext_mobColonSymbol3FG",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1660,
            "y": 1048,

        },
        {

            "name": "Mobiletext_mobColonSymbol3FG",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1660,
            "y": 1048,

        },
        {

            "name": "Mobiletext_bet_valueFG",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1700,
            "y": 1050,


        },
        {

            "name": "Mobiletext_bet_valueFG",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1700,
            "y": 1050,


        },


        {

            "name": "mobileViewBottomBArLineImageFG_1",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 270,
            "y": 872

        },
        {

            "name": "mobileViewBottomBArLineImageFG_1",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 210,
            "y": 1736,

        },
        {

            "name": "mobileViewBottomBArLineImageFG_2",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 870,
            "y": 1736,

        },

        {

            "name": "mobileViewBottomBArLineImageFG_2",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 940,
            "y": 872

        },


        {
            "name": "FG_leftTorchFlame_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 113,
            "y": 684,
        },
        {
            "name": "FG_rightTorchFlame_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1752,
            "y": 684,
        },
        {
            "name": "FG_Left_DrippingLava0_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 293,
            "y": 338,
        },
        {
            "name": "FG_Right_DrippingLava0_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1653,
            "y": 338,
        },
        {
            "name": "FG_Left_DrippingLava1_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 299,
            "y": 461,
        },
        {
            "name": "FG_Right_DrippingLava1_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1621,
            "y": 461,
        },
        {
            "name": "FG_floorLava_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 984,
        },
        {
            "name": "FG_coalLoop_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 137,
            "y": 348,
        }, {
            "name": "FG_coalLoop_Anim_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 167,
            "y": 1178,
        },
        {
            "name": "FG_smoke_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1,
            "y": 546,
        },
        {
            "name": "FG_frontLava_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 910,
            "y": 924,
        },


        {
            "name": "multiWays_text_value_mob",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 812,
            "y": 60,
        }, {
            "name": "multiWays_text_value_mob",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 372,
            "y": 374,
        },
        {
            "name": "Mobiletext_win_label_FG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 365,
            "y": 1640,
        }, {
            "name": "Mobiletext_mobColonSymbol1_FG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 460,
            "y": 1640,
        }, {
            "name": "Mobiletext_win_value_FG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            // "visible": true,
            "x": 630,
            "y": 1640,
        },


        {
            "name": "FG_bugFLies_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },



        {
            "name": "BG_multiwaysText_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 817,
            "y": 67,
        },
        {
            "name": "BG_multiwaysText_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 817,
            "y": 67,
        },
        {
            "name": "BG_multiwaysText_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 400,
            "y": 550,
        },
        {
            "name": "BG_multiwaysText_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 400,
            "y": 550,
        },





        {
            "name": "FG_multiwaysText_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 820,
            "y": 65,
        },
        {
            "name": "FG_multiwaysText_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 387,
            "y": 549,
        },
        {
            "name": "FG_multiwaysText_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 820,
            "y": 65,
        },
        {
            "name": "FG_multiwaysText_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 387,
            "y": 549,
        },

        {
            "name": "BG_textMultiWays_Image_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1022,
            "y": 44,
        },
        {
            "name": "BG_textMultiWays_Image_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 610,
            "y": 353,
        },
        {
            "name": "FG_textMultiWays_Image_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1032,
            "y": 42,
        },
        {
            "name": "FG_textMultiWays_Image_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 616,
            "y": 355,
        },


        {
            "name": "Text_amount_tickup_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 920,
            "y": 680,
        },
        {
            "name": "Text_amount_tickup_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 550,
            "y": 964,
        },
        {
            "name": "text_WinCelebration_label_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 940,
            "y": 475,
        },
        {
            "name": "text_WinCelebration_label_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 551,
            "y": 937,
        },
        {
            "name": "text_WinCelebration_label_mobile_portrait",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 940,
            "y": 475,
        },
        {
            "name": "text_WinCelebration_label_mobile_portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 551,
            "y": 653,
        },
        {
            "name": "bgSpine",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 980,
            "y": 600,
        },
        {
            "name": "bgSpine",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 550,
            "y": 868,
        },
        {
            "name": "mobileMainContainer",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 2,
            "y": 10,
        },
        {
            "name": "mobileMainContainer",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -865,
            "y": -140,
        },
        {
            "name": "mobileMainContainer",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 2,
            "y": 10,
        },
        {
            "name": "mobileMainContainer",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -865,
            "y": -140,
        },
        {
            "name": "leftCaveMaskImage_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 356,
            "y": 63
        },
        {
            "name": "leftCaveMaskImage_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 14,
            "y": 366
        },
        {
            "name": "rightCaveMaskImage_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1404,
            "y": 63
        },
        {
            "name": "rightCaveMaskImage_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 934,
            "y": 366
        },
        {
            "name": "rightCaveMaskImage_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1404,
            "y": 63
        },
        {
            "name": "rightCaveMaskImage_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 934,
            "y": 366
        },
        {
            "name": "btn_introBanner_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 737,
            "y": 564,
        },
        {
            "name": "btn_introBanner_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 340,
            "y": 817
        },
        // {
        //     "name": "introGlowImage_mobile",
        //     "screenMode": "Landscape",
        //     "handMode": "right",
        //     "uiMode": "mobile",
        //     "visible": true,
        //     "x": 984,
        //     "y": 496,
        // },
        // {
        //     "name": "introGlowImage_mobile",
        //     "screenMode": "Portrait",
        //     "handMode": "right",
        //     "uiMode": "mobile",
        //     "visible": true,
        //     "x": 550,
        //     "y": 770
        // },
        {
            "name": "introBg_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 540,
        },
        {
            "name": "introBg_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 544,
            "y": 879
        },
        {
            "name": "introBg_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 540,
        },
        {
            "name": "introBg_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 544,
            "y": 879
        },
        {
            "name": "mountainAnim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1056,
            "y": 192,
        },
        {
            "name": "mountainAnim_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 660,
            "y": 441
        },
        {
            "name": "blastAnim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 895,
            "y": 558,
        },
        {
            "name": "blastAnim_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 540,
            "y": 600
        },
        {
            "name": "text_IntroScreenFG_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 740,
            "y": 310,
        },
        {
            "name": "text_IntroScreenFG_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 336,
            "y": 558
        },
        {
            "name": "text_freeSpinAward_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 745,
            "y": 430,
        },
        {
            "name": "text_freeSpinAward_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 342,
            "y": 677
        },
        {
            "name": "text_1_intro_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1194,
            "y": 470,
        },
        {
            "name": "text_1_intro_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 790,
            "y": 722,
        },
        {
            "name": "text_2_intro_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1196,
            "y": 600,
        },
        {
            "name": "text_2_intro_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 786,
            "y": 844
        },
        {
            "name": "text_3_intro_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1114,
            "y": 729,
        },
        {
            "name": "text_3_intro_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 712,
            "y": 973
        },
        {
            "name": "multiplier_text_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1698,
            "y": 428,
        },
        {
            "name": "multiplier_text_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 834,
            "y": 293,
        },
        {
            "name": "multiplier_text_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1698,
            "y": 428,
        },
        {
            "name": "multiplier_text_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 834,
            "y": 293,
        },

        //{
        //    "name": "backgroundImageOfIntroductionPage_portrait",
        //    "screenMode": "Portrait",
        //    "handMode": "right",
        //    "uiMode": "mobile",
        //    "visible": true,
        //    "x": 0,
        //    "y": 0
        //},


        // {
        //     "name": "postIntro_continueButton_mobile",
        //     "screenMode": "Landscape",
        //     "handMode": "right",
        //     "uiMode": "mobile",
        //     "visible": true,
        //     "x": 715,
        //     "y": 915,
        // },

        // {
        //     "name": "postIntro_continueButton_mobile",
        //     "screenMode": "Portrait",
        //     "handMode": "right",
        //     "uiMode": "mobile",
        //     "visible": true,
        //     "x": 294,
        //     "y": 927
        // },
        {
            "name": "Text_Continue_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 963,
            "y": 970,
        },

        {
            "name": "Text_Continue_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 935,
            "y": 1493
        },
        {
            "name": "hitArea_Graphic_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 337,
            "y": 248,
        },

        {
            "name": "hitArea_Graphic_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 7,
            "y": 536,
        },
        {
            "name": "horizontalHitArea_Graphic_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 544,
            "y": 85,
        },

        {
            "name": "horizontalHitArea_Graphic_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 194,
            "y": 370,
        },




        {
            "name": "FG_reTrigger_blast_Anim_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 754,
            "y": 893,
        },

        {
            "name": "FG_reTrigger_blast_Anim_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 702,
            "y": 1757,
        },





        {
            "name": "amount_tickup_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 966,
            "y": 595,
        },

        {
            "name": "amount_tickup_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 546,
            "y": 834,
        },

        {
            "name": "text_1_OutroScreenFG_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 990,
            "y": 360,
        },
        {
            "name": "text_1_OutroScreenFG_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 990,
            "y": 360,
        },

        {
            "name": "text_1_OutroScreenFG_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 558,
            "y": 652,
        },
        {
            "name": "text_1_OutroScreenFG_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 558,
            "y": 652,
        },



        {
            "name": "text_fg_out_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1826,
            "y": 288,
        },
        {
            "name": "text_fg_out_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1826,
            "y": 288,
        },

        {
            "name": "text_fg_out_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 620,
            "y": 1257,
        },
        {
            "name": "text_fg_out_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 620,
            "y": 1257,
        },







        {
            "name": "text_2_OutroScreenFG_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 957,
            "y": 503,
        },

        {
            "name": "text_2_OutroScreenFG_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 582,
            "y": 781,
        },



        {
            "name": "text_3_OutroScreenFG_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 957,
            "y": 572,
        },
        {
            "name": "text_3_OutroScreenFG_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 957,
            "y": 572,
        },

        {
            "name": "text_3_OutroScreenFG_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 570,
            "y": 952,
        },
        {
            "name": "text_3_OutroScreenFG_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 570,
            "y": 952,
        },




        {
            "name": "winShower_Container_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },

        {
            "name": "winShower_Container_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -350,
            "y": 460,
        },



        {
            "name": "winCelebration_Container_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },

        {
            "name": "winCelebration_Container_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -350,
            "y": 440,
        },

        //outroBImage_mobile

        {
            "name": "outroBImage_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 984,
            "y": 496,
        },

        {
            "name": "outroBImage_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 595,
            "y": 753,
        },

        {
            "name": "image_basegame-bg_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0
        },





        {
            "name": "BG_frame_Image_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 959.5,
            "y": 539.5
        },
        {
            "name": "BG_frame_Image_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 959.5,
            "y": 539.5
        },

        {
            "name": "BG_frame_Image_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 541.5,
            "y": 686.5
        },
        {
            "name": "BG_frame_Image_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 541.5,
            "y": 686.5
        },


        {
            "name": "bg_front_grass_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 329,
            "y": 862
        },
        {
            "name": "bg_front_grass_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 329,
            "y": 862
        },

        {
            "name": "bg_front_grass_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -80,
            "y": 1072
        },
        {
            "name": "bg_front_grass_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -80,
            "y": 1072
        },




        {
            "name": "fg_front_grass_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 329,
            "y": 862
        },
        {
            "name": "fg_front_grass_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 329,
            "y": 862
        },

        {
            "name": "fg_front_grass_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -80,
            "y": 1072
        },
        {
            "name": "fg_front_grass_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -80,
            "y": 1072
        },



        {
            "name": "header_meter_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 484,
            "y": 6
        },
        {
            "name": "header_meter_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 484,
            "y": 6
        },

        {
            "name": "header_meter_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 71,
            "y": 111
        },
        {
            "name": "header_meter_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 71,
            "y": 111
        },







        {
            "name": "win_panel_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 29,
            "y": 327
        },
        {
            "name": "win_panel_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 29,
            "y": 327
        },

        {
            "name": "win_panel_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -9,
            "y": 1162
        },
        {
            "name": "win_panel_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -9,
            "y": 1162
        },






        {
            "name": "total_win_text_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 92,
            "y": 493,
        },
        {
            "name": "total_win_text_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 92,
            "y": 493,
        },

        {
            "name": "total_win_text_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 41,
            "y": 1315
        },
        {
            "name": "total_win_text_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 41,
            "y": 1315
        },






        {
            "name": "total_win_text_freegame_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 189,
            "y": 493
        },
        {
            "name": "total_win_text_freegame_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 189,
            "y": 493
        },

        {
            "name": "total_win_text_freegame_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 139,
            "y": 1315
        },
        {
            "name": "total_win_text_freegame_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 139,
            "y": 1315
        },






        {
            "name": "startText_mob",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1401,
            "y": 972,
        },
        {
            "name": "startText_mob",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1401,
            "y": 972,
        },

        {
            "name": "startText_mob",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 920,
            "y": 1720
        },
        {
            "name": "startText_mob",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 920,
            "y": 1720
        },


        {
            "name": "startText_mobfg",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1401,
            "y": 972,
        },
        {
            "name": "startText_mobfg",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1401,
            "y": 972,
        },

        {
            "name": "startText_mobfg",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 942,
            "y": 1712
        },
        {
            "name": "startText_mobfg",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 942,
            "y": 1712
        },

        {
            "name": "outroBg_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 940,
            "y": 520,
        },
        {
            "name": "outroBg_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 940,
            "y": 520,
        },

        {
            "name": "outroBg_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 545,
            "y": 723
        },
        {
            "name": "outroBg_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 545,
            "y": 723
        },



        {
            "name": "fg_outro_Congratulation_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 940,
            "y": 340,
        },
        {
            "name": "fg_outro_Congratulation_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 940,
            "y": 340,
        },

        {
            "name": "fg_outro_Congratulation_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 556,
            "y": 537
        },
        {
            "name": "fg_outro_Congratulation_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 556,
            "y": 537
        },



        {
            "name": "text_1_OutroScreenFG_desktop_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 450
        },
        {
            "name": "text_1_OutroScreenFG_desktop_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 450
        },

        {
            "name": "text_1_OutroScreenFG_desktop_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 556,
            "y": 647
        },
        {
            "name": "text_1_OutroScreenFG_desktop_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 556,
            "y": 647
        },





        {
            "name": "text_3_OutroScreenFG_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 600,
        },
        {
            "name": "text_3_OutroScreenFG_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 600,
        },

        {
            "name": "text_3_OutroScreenFG_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 556,
            "y": 798
        },
        {
            "name": "text_3_OutroScreenFG_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 556,
            "y": 798
        },



        {
            "name": "fg_intro_Congratulation_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 964,
            "y": 340,
        },
        {
            "name": "fg_intro_Congratulation_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 964,
            "y": 340,
        },

        {
            "name": "fg_intro_Congratulation_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 555,
            "y": 703
        },
        {
            "name": "fg_intro_Congratulation_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 555,
            "y": 703
        },







        {
            "name": "fg_intro_you_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 460,
        },
        {
            "name": "fg_intro_you_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 460,
        },

        {
            "name": "fg_intro_you_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 558,
            "y": 813
        },
        {
            "name": "fg_intro_you_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 558,
            "y": 813
        },





        {
            "name": "fg_intro_count_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 610,
        },
        {
            "name": "fg_intro_count_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 610,
        },

        {
            "name": "fg_intro_count_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 552,
            "y": 959
        },
        {
            "name": "fg_intro_count_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 552,
            "y": 959
        },








        {
            "name": "fg_intro_freespintext_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 750,
        },
        {
            "name": "fg_intro_freespintext_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 750,
        },

        {
            "name": "fg_intro_freespintext_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 552,
            "y": 1105
        },
        {
            "name": "fg_intro_freespintext_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 552,
            "y": 1105
        },





        {
            "name": "fg_intro_clickAnywhereText_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 830,
        },
        {
            "name": "fg_intro_clickAnywhereText_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 830,
        },

        {
            "name": "fg_intro_clickAnywhereText_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 552,
            "y": 1180
        },
        {
            "name": "fg_intro_clickAnywhereText_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 552,
            "y": 1180
        },





        {
            "name": "bodyBuilderCharacterIdle_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1538,
            "y": 987,
        },
        {
            "name": "bodyBuilderCharacterIdle_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 1538,
            "y": 987,
        },

        {
            "name": "bodyBuilderCharacterIdle_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 837,
            "y": 1711
        },
        {
            "name": "bodyBuilderCharacterIdle_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 837,
            "y": 1711
        },




        {
            "name": "skeletonCharacterIdle_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1584,
            "y": 987,
        },
        {
            "name": "skeletonCharacterIdle_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 1584,
            "y": 987,
        },

        {
            "name": "skeletonCharacterIdle_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 886,
            "y": 1711
        },
        {
            "name": "skeletonCharacterIdle_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 886,
            "y": 1711
        },






        {
            "name": "fg_skeletonCharacterIdle_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1584,
            "y": 987,
        },
        {
            "name": "fg_skeletonCharacterIdle_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 1584,
            "y": 987,
        },

        {
            "name": "fg_skeletonCharacterIdle_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 886,
            "y": 1711
        },
        {
            "name": "fg_skeletonCharacterIdle_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 886,
            "y": 1711
        },





        {
            "name": "fg_skeletonCharectarAction_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1584,
            "y": 987,
        },
        {
            "name": "fg_skeletonCharectarAction_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 1584,
            "y": 987,
        },

        {
            "name": "fg_skeletonCharectarAction_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 886,
            "y": 1711
        },
        {
            "name": "fg_skeletonCharectarAction_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 886,
            "y": 1711
        },






        {
            "name": "fg_bodyBuilderCharacterAction_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1584,
            "y": 987,
        },
        {
            "name": "fg_bodyBuilderCharacterAction_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 1584,
            "y": 987,
        },

        {
            "name": "fg_bodyBuilderCharacterAction_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 886,
            "y": 1711
        },
        {
            "name": "fg_bodyBuilderCharacterAction_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 886,
            "y": 1711
        },





        {
            "name": "bodyBuilderCharacterBtn_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1351,
            "y": 816
        },
        {
            "name": "bodyBuilderCharacterBtn_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 1351,
            "y": 816
        },

        {
            "name": "bodyBuilderCharacterBtn_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 871,
            "y": 1564
        },
        {
            "name": "bodyBuilderCharacterBtn_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 871,
            "y": 1564
        },


        {
            "name": "skeletonCharacterBtn_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1351,
            "y": 816
        },
        {
            "name": "skeletonCharacterBtn_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1351,
            "y": 816
        },

        {
            "name": "skeletonCharacterBtn_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 871,
            "y": 1564
        },
        {
            "name": "skeletonCharacterBtn_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 871,
            "y": 1564
        },









        {
            "name": "btnGlowContainermobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1447,
            "y": 905,
        },
        {
            "name": "btnGlowContainermobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1447,
            "y": 905,
        },

        {
            "name": "btnGlowContainermobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 952,
            "y": 1655,
        },
        {
            "name": "btnGlowContainermobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 952,
            "y": 1655,
        },











        {
            "name": "BG_skull_Anim_1_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 941,
            "y": 79,
        },
        {
            "name": "BG_skull_Anim_1_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 941,
            "y": 79,
        },

        {
            "name": "BG_skull_Anim_1_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 531,
            "y": 194
        },
        {
            "name": "BG_skull_Anim_1_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 531,
            "y": 194
        },






        {
            "name": "BG_skull_Anim_2_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 854,
            "y": 79,
        },
        {
            "name": "BG_skull_Anim_2_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 854,
            "y": 79,
        },

        {
            "name": "BG_skull_Anim_2_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 438,
            "y": 194
        },
        {
            "name": "BG_skull_Anim_2_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 438,
            "y": 194
        },


        {
            "name": "BG_skull_Anim_3_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1028,
            "y": 79,
        },
        {
            "name": "BG_skull_Anim_3_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1028,
            "y": 79,
        },

        {
            "name": "BG_skull_Anim_3_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 627,
            "y": 194
        },
        {
            "name": "BG_skull_Anim_3_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 627,
            "y": 194
        },




        {
            "name": "BG_skull_Anim_4_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 778,
            "y": 82,
        },
        {
            "name": "BG_skull_Anim_4_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 778,
            "y": 82,
        },

        {
            "name": "BG_skull_Anim_4_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 348,
            "y": 194
        },
        {
            "name": "BG_skull_Anim_4_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 348,
            "y": 194
        },




        {
            "name": "BG_skull_Anim_5_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1104,
            "y": 82,
        },
        {
            "name": "BG_skull_Anim_5_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1104,
            "y": 82,
        },

        {
            "name": "BG_skull_Anim_5_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 710,
            "y": 194
        },
        {
            "name": "BG_skull_Anim_5_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 710,
            "y": 194
        },





        {
            "name": "bottomBarForPortrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 1754
        },
        {
            "name": "bottomBarForPortrait",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 1754
        },



        {
            "name": "game_logoContainer_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 202,
            "y": 157,
        },
        {
            "name": "game_logoContainer_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 202,
            "y": 157,
        },

        {
            "name": "game_logoContainer_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 529,
            "y": 76,
        },
        {
            "name": "game_logoContainer_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 529,
            "y": 76,
        },





        {
            "name": "FG_frame_Image_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 957.5,
            "y": 527.5
        },
        {
            "name": "FG_frame_Image_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 957.5,
            "y": 527.5
        },

        {
            "name": "FG_frame_Image_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 540.5,
            "y": 671.5,
        },
        {
            "name": "FG_frame_Image_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 540.5,
            "y": 671.5,
        },
        {
            "name": "bg_top_vines_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 344,
            "y": 47
        },
        {
            "name": "bg_top_vines_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 344,
            "y": 47
        },

        {
            "name": "bg_top_vines_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -97,
            "y": 526
        },
        {
            "name": "bg_top_vines_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -97,
            "y": 526
        },



        {
            "name": "fg_top_vinesMob",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 344,
            "y": 47
        },

        {
            "name": "fg_top_vinesMob",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -97,
            "y": 526
        },



        {
            "name": "fg_top_vinesMob",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 344,
            "y": 47
        },

        {
            "name": "fg_top_vinesMob",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -97,
            "y": 526
        },









        {
            "name": "basegame_megaways_banner_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 675,
            "y": 25
        },
        {
            "name": "basegame_megaways_banner_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 675,
            "y": 25
        },

        {
            "name": "basegame_megaways_banner_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 246,
            "y": 509
        },
        {
            "name": "basegame_megaways_banner_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 246,
            "y": 509
        },



        {
            "name": "freegame_megaways_bannerMobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 675,
            "y": 25
        },

        {
            "name": "freegame_megaways_bannerMobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 246,
            "y": 509
        },
        {
            "name": "freegame_megaways_bannerMobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 675,
            "y": 25
        },

        {
            "name": "freegame_megaways_bannerMobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 246,
            "y": 509
        },







        {
            "name": "bgSpine_gamelogo_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 140,
            "y": 270,
        },


        {
            "name": "bgSpine_gamelogo_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 537,
            "y": 270,
        },

        {
            "name": "bg_grass_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 2,
            "y": 773
        },
        {
            "name": "bg_grass_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 2,
            "y": 773
        },

        {
            "name": "bg_grass_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -218,
            "y": 1122
        },
        {
            "name": "bg_grass_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -218,
            "y": 1122
        },
        {
            "name": "fg_grassMob",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 2,
            "y": 773
        },
        {
            "name": "fg_grassMob",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 2,
            "y": 773
        },

        {
            "name": "fg_grassMob",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -218,
            "y": 1122
        },
        {
            "name": "fg_grassMob",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -218,
            "y": 1122
        },


        {
            "name": "Base_game_vines",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 595,
        },
        {
            "name": "Base_game_vines",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 595,
        },

        //{
        //    "name": "Base_game_vines",
        //    "screenMode": "Portrait",
        //    "handMode": "right",
        //    "uiMode": "mobile",
        //    "visible": false,
        //    "x": 960,
        //    "y": 595,
        //},

        {
            "name": "Base_game_vines_butterfly",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 595,
        },
        {
            "name": "Base_game_vines_butterfly",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 595,
        },

        //  {
        //      "name": "Base_game_vines_butterfly",
        //      "screenMode": "Portrait",
        //      "handMode": "right",
        //      "uiMode": "mobile",
        //      "visible": false,
        //      "x": 960,
        //      "y": 595,
        //  },

        {
            "name": "BG_BitMapText_1_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 821,
            "y": 67,
        },

        {
            "name": "BG_BitMapText_1_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 821,
            "y": 67,
        },


        {
            "name": "paytableBack",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 542,
        },
        {
            "name": "paytableBack",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 648,
        },

        {
            "name": "paytableBack",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 698,
            "y": 1313,
        },

        {
            "name": "paytableBack",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 286,
            "y": 1313,
        },


        {
            "name": "paytableBackFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 698,
            "y": 1313,
        },

        {
            "name": "paytableBackFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 286,
            "y": 1313,
        },





        {
            "name": "btn_paytable",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 84,
            "y": 575,
        },

        {
            "name": "btn_paytable",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1737,
            "y": 680,
        },

        {
            "name": "btn_paytable",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 732,
            "y": 1343,
        },

        {
            "name": "btn_paytable",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 321,
            "y": 1348,
        },



        {
            "name": "btn_paytableFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 732,
            "y": 1343,
        },

        {
            "name": "btn_paytableFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 321,
            "y": 1348,
        },

        {
            "name": "ui_base_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 996,
        },
        {
            "name": "ui_base_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 996,
        },



        {
            "name": "ui_base_mobileMenu",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 996,
        },

        //{
        //    "name": "ui_base_mobile",
        //    "screenMode": "Portrait",
        //    "handMode": "right",
        //    "uiMode": "mobile",
        //    "visible": true,
        //    "x": 0,
        //    "y": 996,
        //},







        {
            "name": "btn_sound",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 370,
        },
        {
            "name": "btn_sound",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 430,
        },

        {
            "name": "btn_sound",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 286,
            "y": 1313,
        },
        {
            "name": "btn_sound",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 698,
            "y": 1313,
        },




        {
            "name": "btn_soundOff",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 51,
            "y": 370,
        },
        {
            "name": "btn_soundOff",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 1702,
            "y": 430,
        },

        {
            "name": "btn_soundOff",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 286,
            "y": 1313,
        },

        {
            "name": "btn_soundOff",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 698,
            "y": 1313,
        },


        {
            "name": "btn_soundFG",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 370,
        },
        {
            "name": "btn_soundFG",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 370,
        },

        {
            "name": "btn_soundFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 286,
            "y": 1313,
        },
        {
            "name": "btn_soundFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 698,
            "y": 1313,
        },



        {
            "name": "btn_soundOffFG",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 51,
            "y": 370,
        },
        {
            "name": "btn_soundOffFG",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 51,
            "y": 370,
        },

        {
            "name": "btn_soundOffFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 286,
            "y": 1313,
        },

        {
            "name": "btn_soundOffFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 698,
            "y": 1313,
        },






        {
            "name": "soundBack",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 369,
        },
        {
            "name": "soundBack",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 430,
        },

        {
            "name": "soundBack",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 286,
            "y": 1313,
        },
        {
            "name": "soundBack",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 698,
            "y": 1313,
        },


        {
            "name": "soundBackFG",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 369,
        },
        {
            "name": "soundBackFG",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 369,
        },

        {
            "name": "soundBackFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 286,
            "y": 1313,
        },
        {
            "name": "soundBackFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 698,
            "y": 1313,
        },



        {
            "name": "menuBack",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 220,
        },
        {
            "name": "menuBack",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 340,
        },

        {
            "name": "menuBack",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 254,
            "y": 1489,
        },
        {
            "name": "menuBack",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 728,
            "y": 1489,
        },

        {
            "name": "menuBackFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 254,
            "y": 1489,
        },
        {
            "name": "menuBackFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 254,
            "y": 1489,
        },



        {
            "name": "btn_menu",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 221,
        },
        {
            "name": "btn_menu",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 340,
        },

        {
            "name": "btn_menu",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 254,
            "y": 1489,
        },
        {
            "name": "btn_menu",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 728,
            "y": 1489,
        },



        {
            "name": "btn_menuFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 254,
            "y": 1489,
        },
        {
            "name": "btn_menuFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 728,
            "y": 1489,
        },


        {
            "name": "btn_menu_close",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 221,
        },
        {
            "name": "btn_menu_close",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 350,
        },

        {
            "name": "btn_menu_close",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 221,
        },


        {
            "name": "stakeBack",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 621,
        },
        {
            "name": "stakeBack",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 740,
        },

        {
            "name": "stakeBack",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 728,
            "y": 1489,
        },
        {
            "name": "stakeBack",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 254,
            "y": 1489,
        },


        {
            "name": "stakeBackFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 728,
            "y": 1489,
        },
        {
            "name": "stakeBackFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 728,
            "y": 1489,
        },


        {
            "name": "btn_stake",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 625,
        },
        {
            "name": "btn_stake",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 51,
            "y": 736,
        },

        {
            "name": "btn_stake",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 728,
            "y": 1489,
        },
        {
            "name": "btn_stake",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 254,
            "y": 1489,
        },


        {
            "name": "btn_stakeFG",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 728,
            "y": 1489,
        },
        {
            "name": "btn_stakeFG",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 254,
            "y": 1489,
        },

        {
            "name": "postIntro_continueButton_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1677,
            "y": 976,
        },

        {
            "name": "postIntro_continueButton_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 856,
            "y": 1463,
        },


        //     {
        //         "name": "radio_button_off_mobile",
        //         "screenMode": "Landscape",
        //         "handMode": "right",
        //         "uiMode": "mobile",
        //         "visible": true,
        //         "x": 80,
        //         "y": 976,
        //     },

        //     {
        //         "name": "radio_button_off_mobile",
        //         "screenMode": "Portrait",
        //         "handMode": "right",
        //         "uiMode": "mobile",
        //         "visible": true,
        //         "x": 50,
        //         "y": 1463,
        //     },






        //     {
        //         "name": "radio_button_on_mobile",
        //         "screenMode": "Landscape",
        //         "handMode": "right",
        //         "uiMode": "mobile",
        //         "visible": true,
        //         "x": 80,
        //         "y": 976,
        //     },

        //     {
        //         "name": "radio_button_on_mobile",
        //         "screenMode": "Portrait",
        //         "handMode": "right",
        //         "uiMode": "mobile",
        //         "visible": true,
        //         "x": 50,
        //         "y": 1463,
        //     },





        {
            "name": "displayOnLoadText_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 280,
            "y": 1005,
        },

        {
            "name": "displayOnLoadText_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 260,
            "y": 1487,
        },


        {
            "name": "backgroundGraphicSettingPanel",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },

        {
            "name": "backgroundGraphicSettingPanel",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },




        {
            "name": "topBar",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },

        {
            "name": "topBar",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },





        {
            "name": "sideBar",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1710,
            "y": 0,
        },

        {
            "name": "sideBar",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1710,
            "y": 0,
        },





        {
            "name": "buttonscontainer",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1768,
            "y": 0,
        },

        {
            "name": "buttonscontainer",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1787,
            "y": 0,
        },





        {
            "name": "settingPanelCloseButton",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 64,
            "y": 82,
        },

        {
            "name": "settingPanelCloseButton",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 64,
            "y": 82,
        },




        {
            "name": "yellowLine",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 674,
            "y": 177,
        },

        {
            "name": "yellowLine",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 674,
            "y": 177,
        },





        {
            "name": "autoplayBtnMobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -701,
            "y": 53,
        },

        {
            "name": "autoplayBtnMobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -701,
            "y": 53,
        },






        {
            "name": "gameSettingsBtnMobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -1419,
            "y": 53,
        },

        {
            "name": "gameSettingsBtnMobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -1419,
            "y": 53,
        },

        {
            "name": "btn_setting_text2_yellow",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": -551,
            "y": 97,
        },

        {
            "name": "btn_setting_text2_yellow",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": -551,
            "y": 97,
        },


        {
            "name": "btn_setting_text1_yellow",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": -1277,
            "y": 97,
        },

        {
            "name": "btn_setting_text1_yellow",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": -1277,
            "y": 97,
        },





        {
            "name": "btn_setting_text2_white",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": -551,
            "y": 97,
        },

        {
            "name": "btn_setting_text2_white",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": -551,
            "y": 97,
        },



        {
            "name": "btn_setting_text1_white",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": -1277,
            "y": 97,
        },

        {
            "name": "btn_setting_text1_white",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": -1277,
            "y": 97,
        },




        //   {
        //       "name": "BG_frame_Image_Mobile",
        //       "screenMode": "Landscape",
        //       "handMode": "right",
        //       "uiMode": "mobile",
        //       "visible": true,
        //       "x": 957.5,
        //       "y": 539.5
        //   },

        //   {
        //       "name": "BG_frame_Image_Mobile",
        //       "screenMode": "Portrait",
        //       "handMode": "right",
        //       "uiMode": "mobile",
        //       "visible": true,
        //       "x": 541.5,
        //       "y": 1017.5,
        //   },



        // {
        //     "name": "freegame_megaways_bannerMobile",
        //     "screenMode": "Landscape",
        //     "handMode": "right",
        //     "uiMode": "mobile",
        //     "visible": true,
        //     "x": 675,
        //     "y": 25
        // },

        // {
        //     "name": "freegame_megaways_bannerMobile",
        //     "screenMode": "Portrait",
        //     "handMode": "right",
        //     "uiMode": "mobile",
        //     "visible": true,
        //     "x": 675,
        //     "y": 25
        // },




        {
            "name": "game_logo",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 140,
            "y": 270,
        },
        {
            "name": "game_logo",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 140,
            "y": 270,
        },

        {
            "name": "game_logo",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 537,
            "y": 341,
        },
        {
            "name": "game_logo",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 537,
            "y": 341,
        },



        // {
        //     "name": "fg_grassMob",
        //     "screenMode": "Landscape",
        //     "handMode": "right",
        //     "uiMode": "mobile",
        //     "visible": true,
        //     "x": 2,
        //     "y": 773
        // },

        // {
        //     "name": "fg_grassMob",
        //     "screenMode": "Portrait",
        //     "handMode": "right",
        //     "uiMode": "mobile",
        //     "visible": true,
        //     "x": 2,
        //     "y": 773
        // },



        {
            "name": "Free_game_vines",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 595,
        },
        {
            "name": "Free_game_vines",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 595,
        },

        //    {
        //        "name": "Free_game_vines",
        //        "screenMode": "Portrait",
        //        "handMode": "right",
        //        "uiMode": "mobile",
        //        "visible": true,
        //        "x": 960,
        //        "y": 595,
        //    },









        {
            "name": "fgRemainingFrameMob",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1675,
            "y": 190
        },

        {
            "name": "fgRemainingFrameMob",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 6,
            "y": 234
        },
        {
            "name": "fgRemainingFrameMob",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1675,
            "y": 190
        },

        {
            "name": "fgRemainingFrameMob",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 6,
            "y": 234
        },






        {
            "name": "fgOutOfImageMob",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1735,
            "y": 234
        },

        {
            "name": "fgOutOfImageMob",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 95,
            "y": 301
        },
        {
            "name": "fgOutOfImageMob",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1735,
            "y": 234
        },

        {
            "name": "fgOutOfImageMob",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 95,
            "y": 301
        },

        {
            "name": "backgroundGraphic_portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },


        {
            "name": "assetsContainerOfSoundWithoutBg_portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },


        {
            "name": "portraitSideLeaves",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -55,
            "y": 554
        },
        {
            "name": "portraitSideLeaves",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -55,
            "y": 554
        },
        {
            "name": "portraitSideLeavesFg",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -55,
            "y": 554
        },
        {
            "name": "portraitSideLeavesFg",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -55,
            "y": 554
        },
        {
            "name": "portraitSideLeavesFg",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": -55,
            "y": 554
        },
        {
            "name": "portraitSideLeavesFg",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": -55,
            "y": 554
        },

        {
            "name": "fg_intro_CongratulationMob",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 260,
        },

        {
            "name": "fg_intro_CongratulationMob",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 561,
            "y": 694,
        },
        {
            "name": "fg_intro_CongratulationMob",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 260,
        },

        {
            "name": "fg_intro_CongratulationMob",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 561,
            "y": 694,
        },



        {
            "name": "fg_intro_you",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 470,
        },

        {
            "name": "fg_intro_you",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 559,
            "y": 805,
        },
        {
            "name": "fg_intro_you",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 470,
        },

        {
            "name": "fg_intro_you",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 559,
            "y": 805,
        },


        {
            "name": "fg_intro_count",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 540,
        },

        {
            "name": "fg_intro_count",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 554,
            "y": 926,
        },
        {
            "name": "fg_intro_count",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 540,
        },

        {
            "name": "fg_intro_count",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 554,
            "y": 926,
        },



        {
            "name": "fg_intro_freespintext",

            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 680,
        },

        {
            "name": "fg_intro_freespintext",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 554,
            "y": 1066,
        },
        {
            "name": "fg_intro_freespintext",

            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 955,
            "y": 680,
        },

        {
            "name": "fg_intro_freespintext",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 554,
            "y": 1066,
        },


        {
            "name": "winCelebration_Container_mobile",

            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },

        {
            "name": "winCelebration_Container_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": -50,
        },

        {

            "name": "desk_autoplay_base_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,

        },
        {

            "name": "desk_autoplay_base_mobile_portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,

        },
        {

            "name": "autoplay_losslimitlbl",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 100,
            "y": 200,

        },
        {

            "name": "autoplay_losslimitlbl",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 115,
            "y": 110,

        },
        {

            "name": "funText1",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 215,

        },
        {

            "name": "funText1",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1315,
            "y": 114,

        },
        {

            "name": "sliderDot_inputBoxText",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,

        },
        {

            "name": "sliderDot_inputBoxText",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 293,
            "y": 127,

        },
        {

            "name": "LossLimitBtn1",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 200,
            "y": 300,

        },
        {

            "name": "LossLimitBtn1",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 235,
            "y": 212,

        },
        {

            "name": "LossLimitBtn2",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 500,
            "y": 300,

        },
        {

            "name": "LossLimitBtn2",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 502,
            "y": 212,

        },
        {

            "name": "LossLimitBtn3",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 800,
            "y": 300,

        },
        {

            "name": "LossLimitBtn3",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 769,
            "y": 212,

        },
        {

            "name": "LossLimitBtn4",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 350,
            "y": 400,

        },
        {

            "name": "LossLimitBtn4",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1036,
            "y": 212,

        },
        {

            "name": "LossLimitBtn5",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 650,
            "y": 400,

        },
        {

            "name": "LossLimitBtn5",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1303,
            "y": 212,

        },
        {

            "name": "autoplay_winLimitlbl",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 100,
            "y": 600,

        },
        {

            "name": "autoplay_winLimitlbl",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 115,
            "y": 320,

        },
        {

            "name": "funText2",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 615,

        },
        {

            "name": "funText2",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1315,
            "y": 324,

        },
        {

            "name": "sliderDot_2_inputBoxText",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,

        },
        {

            "name": "sliderDot_2_inputBoxText",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 293,
            "y": 327,

        },
        {

            "name": "winLimitBtn1",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 200,
            "y": 700,

        },
        {

            "name": "winLimitBtn1",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 235,
            "y": 422,

        },
        {

            "name": "winLimitBtn2",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 500,
            "y": 700,

        },
        {

            "name": "winLimitBtn2",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 502,
            "y": 422,

        },
        {

            "name": "winLimitBtn3",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 800,
            "y": 700,

        },
        {

            "name": "winLimitBtn3",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 769,
            "y": 422,

        },
        {

            "name": "winLimitBtn4",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 350,
            "y": 800,

        },
        {

            "name": "winLimitBtn4",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1036,
            "y": 422,

        },
        {

            "name": "winLimitBtn5",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 650,
            "y": 800,

        },
        {

            "name": "winLimitBtn5",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1303,
            "y": 422,

        },
        {

            "name": "autoplay_singleWinLimitlbl",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 100,
            "y": 1000,

        },
        {

            "name": "autoplay_singleWinLimitlbl",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 115,
            "y": 570,

        },
        {

            "name": "funText3",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 1015,

        },
        {

            "name": "funText3",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1315,
            "y": 574,

        },
        {

            "name": "sliderDot_3_inputBoxText",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,

        },
        {

            "name": "sliderDot_3_inputBoxText",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 293,
            "y": 587,

        },
        {

            "name": "singleWinLimitBtn1",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 200,
            "y": 1100,

        },
        {

            "name": "singleWinLimitBtn1",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 235,
            "y": 672,

        },
        {

            "name": "singleWinLimitBtn2",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 500,
            "y": 1100,

        },
        {

            "name": "singleWinLimitBtn2",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 502,
            "y": 672,

        },
        {

            "name": "singleWinLimitBtn3",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 800,
            "y": 1100,

        },
        {

            "name": "singleWinLimitBtn3",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 769,
            "y": 672,

        },
        {

            "name": "singleWinLimitBtn4",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 350,
            "y": 1200,

        },
        {

            "name": "singleWinLimitBtn4",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1036,
            "y": 672,

        },
        {

            "name": "singleWinLimitBtn5",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 650,
            "y": 1200,

        },
        {

            "name": "singleWinLimitBtn5",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1303,
            "y": 672,

        },

        {

            "name": "onAnyWinText",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 200,
            "y": 1400,

        },
        {

            "name": "onAnyWinText",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 226,
            "y": 897,

        },
        {

            "name": "radioButtonOnAnyWin",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 1400,

        },
        {

            "name": "radioButtonOnAnyWin",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1344,
            "y": 895,

        },
        {

            "name": "radioButtonOffOnAnyWin",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 1400,

        },
        {

            "name": "radioButtonOffOnAnyWin",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1344,
            "y": 895,

        },
        {

            "name": "radioButtonOnOnFeature",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 1500,

        },
        {

            "name": "radioButtonOnOnFeature",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1344,
            "y": 802,

        },
        {

            "name": "radioButtonOffOnFeature",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 1500,

        },
        {

            "name": "radioButtonOffOnFeature",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1344,
            "y": 802,

        },
        {

            "name": "onFeatureTriggeredText",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 200,
            "y": 1500,

        },
        {

            "name": "onFeatureTriggeredText",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 256,
            "y": 797,

        },
        {

            "name": "autoplay_StartButton",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1663,
            "y": 373,

        },
        {

            "name": "autoplay_StartButton",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 413,
            "y": 1527,

        },
        {

            "name": "autoplay_StartButton",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 413,
            "y": 1527,

        },


        {

            "name": "autoplay_StartButtonStroke",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1604,
            "y": 357,

        },
        {

            "name": "autoplay_StartButtonStroke",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 655,
            "y": 1462,

        },
        {

            "name": "autoplay_StartButtonStroke",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 655,
            "y": 1462,

        },

        {
            "name": "container_basegame_text1",

            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 408,
            "y": 1022,
        },
        {
            "name": "container_basegame_text1",

            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 408,
            "y": 1022,
        },



        {
            "name": "container_basegame_text2",

            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -396,
            "y": 1022,
        },
        {
            "name": "container_basegame_text2",

            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -396,
            "y": 1022,
        },

        {
            "name": "container_basegame_text3",

            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 850,
            "y": 1060,
        },
        {
            "name": "container_basegame_text3",

            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 850,
            "y": 1060,
        },

        {
            "name": "container_basegame_text3",

            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 432,
            "y": 1876,
        },
        {
            "name": "container_basegame_text3",

            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 432,
            "y": 1876,
        },


        {
            "name": "container_basegame_text2_portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -389,
            "y": 1760,
        },


        {
            "name": "container_basegame_text1_portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -389,
            "y": 1760,
        },

        {
            "name": "gameName_label_bottom_portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -21,
            "y": 815,
        },
        {
            "name": "gameName_label_bottom_portrait",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -21,
            "y": 815,
        },

        {
            "name": "gameName_label_bottom_portraitMenu",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -21,
            "y": 815,
        },
        {
            "name": "gameName_label_bottom_portraitMenu",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -21,
            "y": 815,
        },
        {
            "name": "gameName_label_bottom",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },
       
        {
            "name": "gameName_label_bottom",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -21,
            "y": 815,
        },

        {
            "name": "gameName_label_bottommMenu",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },
        {
            "name": "gameName_label_bottomMenu",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },




        {
            "name": "increaseBackPanel",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 220,
        },

        {
            "name": "increaseBackPanel",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 712,
            "y": 1567,
        },
        {
            "name": "increaseBackPanel",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 221,
            "y": 1567,
        },




        {
            "name": "decreaseBackPanel",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1702,
            "y": 621,
        },

        {
            "name": "decreaseBackPanel",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 221,
            "y": 1567,
        },
        {
            "name": "decreaseBackPanel",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 712,
            "y": 1567,
        },





        {
            "name": "autoplayCount_increases",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1744,
            "y": 262,
        },

        {
            "name": "autoplayCount_increases",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 754,
            "y": 1607,
        },
        {
            "name": "autoplayCount_increases",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 261,
            "y": 1607,
        },



        {
            "name": "autoplayCount_decreases",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1744,
            "y": 666,
        },

        {
            "name": "autoplayCount_decreases",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 261,
            "y": 1607,
        },
        {
            "name": "autoplayCount_decreases",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 754,
            "y": 1607,
        },



        {
            "name": "autoplay_CancelButton",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1613,
            "y": 466,
        },

        {
            "name": "autoplay_CancelButton",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 510,
            "y": 1473,
        },
        {
            "name": "autoplay_CancelButton",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 510,
            "y": 1473,
        },




        {
            "name": "autoplay_count",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1776,
            "y": 490,
        },

        {
            "name": "autoplay_count",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 523,
            "y": 1640,
        },
        {
            "name": "autoplay_count",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 523,
            "y": 1640,
        },

        {
            "name": "betPanelContainer",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 688,
            "y": 910,
        },

        {
            "name": "betPanelContainer",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 282,
            "y": 1656,
        },
        {
            "name": "betPanelContainer",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 282,
            "y": 1656,
        },


        {
            "name": "Text_COUNT_APmobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1777,
            "y": 489,
        },

        {
            "name": "Text_COUNT_APmobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 550,
            "y": 1526,
        },
        {
            "name": "Text_COUNT_APmobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 550,
            "y": 1526,
        },

        //freegame



        {
            "name": "total_win_meter_fg_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 29,
            "y": 323
        },
        {
            "name": "total_win_meter_fg_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 29,
            "y": 323
        },

        {
            "name": "total_win_meter_fg_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -9,
            "y": 1162
        },
        {
            "name": "total_win_meter_fg_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -9,
            "y": 1162
        },



        {
            "name": "fg_bodyBuilderCharecterIdle_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1538,
            "y": 987,
        },
        {
            "name": "fg_bodyBuilderCharecterIdle_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 1538,
            "y": 987,
        },

        {
            "name": "fg_bodyBuilderCharecterIdle_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 844,
            "y": 1705
        },
        {
            "name": "fg_bodyBuilderCharecterIdle_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 844,
            "y": 1705
        },



        {
            "name": "fg_bodyBuilderCharacterBtn_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 1349,
            "y": 814
        },
        {
            "name": "fg_bodyBuilderCharacterBtn_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 1349,
            "y": 814
        },

        {
            "name": "fg_bodyBuilderCharacterBtn_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 890,
            "y": 1556
        },
        {
            "name": "fg_bodyBuilderCharacterBtn_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 890,
            "y": 1556
        },




        {
            "name": "fg_skeletonCharacterBtn_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1349,
            "y": 814
        },
        {
            "name": "fg_skeletonCharacterBtn_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1349,
            "y": 814
        },

        {
            "name": "fg_skeletonCharacterBtn_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 890,
            "y": 1556
        },
        {
            "name": "fg_skeletonCharacterBtn_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 890,
            "y": 1556
        },












        {
            "name": "FG_skull_Anim_1_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 941,
            "y": 79,
        },
        {
            "name": "FG_skull_Anim_1_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 941,
            "y": 79,
        },

        {
            "name": "FG_skull_Anim_1_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 487,
            "y": 181
        },
        {
            "name": "FG_skull_Anim_1_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 487,
            "y": 181
        },




        {
            "name": "FG_skull_Anim_2_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 854,
            "y": 79,
        },
        {
            "name": "FG_skull_Anim_2_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 854,
            "y": 79,
        },

        {
            "name": "FG_skull_Anim_2_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 397,
            "y": 181
        },
        {
            "name": "FG_skull_Anim_2_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 397,
            "y": 181
        },





        {
            "name": "FG_skull_Anim_3_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1028,
            "y": 79,
        },
        {
            "name": "FG_skull_Anim_3_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1028,
            "y": 79,
        },

        {
            "name": "FG_skull_Anim_3_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 574,
            "y": 181
        },
        {
            "name": "FG_skull_Anim_3_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 574,
            "y": 181
        },




        {
            "name": "FG_skull_Anim_4_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 778,
            "y": 82,
        },
        {
            "name": "FG_skull_Anim_4_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 778,
            "y": 82,
        },

        {
            "name": "FG_skull_Anim_4_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 319,
            "y": 181
        },
        {
            "name": "FG_skull_Anim_4_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 319,
            "y": 181
        },



        {
            "name": "FG_skull_Anim_5_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1104,
            "y": 82,
        },
        {
            "name": "FG_skull_Anim_5_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1104,
            "y": 82,
        },

        {
            "name": "FG_skull_Anim_5_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 650,
            "y": 181
        },
        {
            "name": "FG_skull_Anim_5_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 650,
            "y": 181
        },



        {
            "name": "bottomBarForPortrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 1754
        },
        {
            "name": "bottomBarForPortrait",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 1754
        },




        {
            "name": "animChangeEffectContainer_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1585,
            "y": 976,
        },
        {
            "name": "animChangeEffectContainer_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1585,
            "y": 976,
        },

        {
            "name": "animChangeEffectContainer_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 837,
            "y": 1700
        },
        {
            "name": "animChangeEffectContainer_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 837,
            "y": 1700
        },





        {
            "name": "fg_animChangeEffect_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1640,
            "y": 976,
        },
        {
            "name": "fg_animChangeEffect_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1640,
            "y": 976,
        },

        {
            "name": "fg_animChangeEffect_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 837,
            "y": 1700
        },
        {
            "name": "fg_animChangeEffect_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 837,
            "y": 1700
        },

        {
            "name": "fg_banner_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1609,
            "y": 210
        },
        {
            "name": "fg_banner_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 1609,
            "y": 210
        },

        {
            "name": "fg_banner_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 406,
            "y": 1178
        },
        {
            "name": "fg_banner_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 406,
            "y": 1178
        },


        {
            "name": "freegameLeave_mobile_container",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 934,
            "y": 552,
        },
        {
            "name": "freegameLeave_mobile_container",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 934,
            "y": 552,
        },




        {
            "name": "mobileMainContainer",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 4,
        },
        {
            "name": "mobileMainContainer",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 4,
        },

        {
            "name": "mobileMainContainer",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -54,
            "y": 836,
        },
        {
            "name": "mobileMainContainer",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -54,
            "y": 836,
        },







        {
            "name": "SkullMainContainer_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },
        {
            "name": "SkullMainContainer_mobile",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },

        {
            "name": "SkullMainContainer_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -555,
            "y": 94,
        },
        {
            "name": "SkullMainContainer_mobile",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": -555,
            "y": 94,
        },



        {
            "name": "winCelebration_Container_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 0,
            "y": 0,
        },

        {
            "name": "winCelebration_Container_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": -350,
            "y": 440,
        },



        {
            "name": "bgSpine_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 935,
            "y": 585,
        },

        {
            "name": "bgSpine_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 530,
            "y": 806,
        },



        {
            "name": "bonusBuyBtn_mobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1780,
            "y": 164,
        },

        {
            "name": "bonusBuyBtn_mobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 974,
            "y": 187,
        },





        {
            "name": "btn_continue_intro",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 565,
            "y": 1300,
        },
        {
            "name": "btn_continue_intro",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 565,
            "y": 1300,
        },
        {
            "name": "btn_continue_intro",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 964,
        },
        {
            "name": "btn_continue_intro",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 960,
            "y": 964,
        },

        {

            "name": "btn_continue_intro",
            "handMode": "left",
            "screenMode": "Landscape",
            "uiMode": "desktop",
            "visible": true,
            "x": 955,
            "y": 964,

        },
        {

            "name": "btn_continue_intro",
            "handMode": "right",
            "screenMode": "Landscape",
            "uiMode": "desktop",
            "visible": true,
            "x": 955,
            "y": 964,

        },
        {
            "name": "introPanelSkipGraphic",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 425,
            "y": 1264,
        },
        {
            "name": "introPanelSkipGraphic",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 425,
            "y": 1264,
        },
        {
            "name": "introPanelSkipGraphic",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 819,
            "y": 928,
        },
        {
            "name": "introPanelSkipGraphic",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": true,
            "x": 819,
            "y": 928,
        },

        {

            "name": "introPanelSkipGraphic",
            "handMode": "left",
            "screenMode": "Landscape",
            "uiMode": "desktop",
            "visible": true,
            "x": 819,
            "y": 928,

        },
        {

            "name": "introPanelSkipGraphic",
            "handMode": "right",
            "screenMode": "Landscape",
            "uiMode": "desktop",
            "visible": true,
            "x": 819,
            "y": 928,

        },

        {

            "name": "radioButtonOnOnFeature_Portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 1500,

        },
        {

            "name": "radioButtonOnOnFeature_Portrait",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1344,
            "y": 802,

        },
        {

            "name": "radioButtonOffOnFeature_Portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 1500,

        },
        {

            "name": "radioButtonOffOnFeature_Portrait",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1344,
            "y": 802,

        },
        {

            "name": "radioButtonOffOnAnyWin_Portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 1400,

        },
        {

            "name": "radioButtonOffOnAnyWin_Portrait",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1344,
            "y": 895,

        },
        {

            "name": "radioButtonOnAnyWin_Portrait",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 900,
            "y": 1400,

        },
        {

            "name": "radioButtonOnAnyWin_Portrait",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 1344,
            "y": 895,

        },

        {
            "name": "insufficientFunds",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 540,
            "y": 1878,
        },
        {
            "name": "insufficientFunds",
            "screenMode": "Portrait",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 540,
            "y": 1878,
        },
        {
            "name": "insufficientFunds",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 963,
            "y": 1062,
        },
        {
            "name": "insufficientFunds",
            "screenMode": "Landscape",
            "handMode": "left",
            "uiMode": "mobile",
            "visible": false,
            "x": 963,
            "y": 1062,
        },
        {
            "name": "buyFeatureStakeExceeds",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 532,
            "y": 1882,

        },
        {

            "name": "buyFeatureStakeExceeds",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": false,
            "x": 963,
            "y": 1062,

        },
        {
            "name": "baseGamerReconstructionMobile",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 215,
            "y": 682,

        },
        {

            "name": "baseGamerReconstructionMobile",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 650,
            "y": 300,

        },


        {
            "name": "max_popup",
            "screenMode": "Landscape",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 648,
            "y": 300
        },

        {
            "name": "max_popup",
            "screenMode": "Portrait",
            "handMode": "right",
            "uiMode": "mobile",
            "visible": true,
            "x": 215,
            "y": 712
        },
    ]

}